import React from 'react';

const Image = ({
    config,
    src = config?.src,
    alt = config?.alt || 'Image',
    radius = config?.radius,
    className = config?.className || '',
    width = config?.width,
    height = config?.height,
    style = config?.style || {},
}) => {
    if (radius) {
        className += ` ${radius}`;
    }
    
    const imageStyle = { ...style };
    if (width) {
        imageStyle.width = typeof width === 'number' ? `${width}px` : width;
        imageStyle.maxWidth = 'none'; // Override CSS max-width when width is set
    }
    if (height) {
        imageStyle.height = typeof height === 'number' ? `${height}px` : height;
        imageStyle.maxHeight = 'none'; // Override CSS max-height when height is set
    }
    
    return (
        <>
            <img
                className={className}
                src={src}
                alt={alt}
                style={Object.keys(imageStyle).length > 0 ? imageStyle : undefined}
            />
        </>
    );
};

export default Image;
